const fruitPulpData = {
  hero_section: {
    title: "Marinated Chicken Collection",
    description: "100% Natural • No Preservatives • Rich in Flavor",
    src: "videos/chickenmarinate.webm",
  },
  description: {
    title: "Premium Marinated Chicken Collection",
    main_description:
      "Discover our range of 100% natural marinated chicken, crafted to preserve the authentic flavors and freshness of the finest ingredients.",
    segment_description:
      "Effortless meal preparation with our ready-to-use marinated chicken.",
    variety_description:
      "Available in a variety of flavors and pack sizes to suit every need.",
  },
  "products": [
    {
      "id": "1",
      "name": "Zesty 9pcs Cut W/S",
      "image": "mc_9pc_sc.webp",
      "features": [
        "Premium chicken cuts",
        "Kerala-style marination",
        "Ready to cook",
        "Perfect for family meals"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "2",
      "name": "Zesty Breast strips S/L",
      "image": "mc_breaststips_sc.webp",
      "features": [
        "Lean protein cuts",
        "Perfect portion size",
        "Quick cooking time",
        "Ideal for salads & wraps"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "3",
      "name": "Zesty Drumsticks W/S",
      "image": "mc_drum_sc.webp",
      "features": [
        "Perfect for grilling",
        "High protein content",
        "Ready to cook",
        "Ideal for parties"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "4",
      "name": "Zesty Lollypop W/S ",
      "image": "mc_lolipop_sc.webp",
      "features": [
        "Perfect for parties",
        "High protein content",
        "Ready to cook",
        "Ideal for kids"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "5",
      "name": "Zesty Thigh Fillet W/S",
      "image": "mc_thigh_sc.webp",
      "features": [
        "Perfect for grilling",
        "High protein content",
        "Ready to cook",
        "Ideal for salads & wraps"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "6",
      "name": "Zesty Winglets W/S",
      "image": "mc_wings_sc.webp",
      "features": [
        "Perfect for grilling",
        "High protein content",
        "Ready to cook",
        "Ideal for salads & wraps"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    }
  ],

  features: [
    {
      id: 1,
      title: "100% Natural Ingredients",
      description: "Made from fresh, high-quality fruits without additives.",
    },
    {
      id: 2,
      title: "Convenient and Ready to Use",
      description: "Save prep time with pulps that are ready out of the pack.",
    },
    {
      id: 3,
      title: "Rich in Flavor and Nutrition",
      description: "Vitamins, antioxidants, and authentic fruit taste.",
    },
    {
      id: 4,
      title: "Versatile Applications",
      description: "Great for smoothies, desserts, beverages, and more.",
    },
  ],
  text_section: {
    title: "Marinated Chicken",
    description: "Our marinated chicken is a celebration of bold flavors and effortless cooking. Crafted using our signature marination formula—a unique fusion of Kerala's globally renowned aromatic spices and the fiery punch of Guntur karam—each bite delivers a burst of authenticity.",
  },
  feature_text_section: {
    title: "Effortless Prep for Chefs",
    subline: "Just marinate, cook, and serve – authentic flavor in every bite!",
    description:
      "Perfect for restaurants, cafes, and catering—our marinated chicken saves prep time and ensures consistent quality.",
  },
  feature_cards_info_card: [
    {
      id: 1,
      image: "mc_horeca_1.webp",
      title: "Faster Prep Time",
      description:
        "Ready-to-cook marinated chicken eliminates time-consuming prep, allowing your kitchen to operate more efficiently.",
    },
    {
      id: 2,
      image: "mc_horeca_3.webp",
      title: "Reduced Wastage",
      description:
        "Precise portions and longer shelf life mean minimal waste, helping you maintain better inventory control and cost efficiency.",
    },
    {
      id: 3,
      image: "mc_horeca_2.webp",
      title: "High-Volume Kitchen",
      description:
        "Perfect for high-volume kitchens: consistent taste, texture, and quality in every batch.",
    },
  ],
  overlay_card: [
    {
      id: 1,
      key: "Signature Spice Blend",
      image: "Signature_Spice_Blend.webp",
      title: "Signature Spice Blend",
      description:
        "Infused with authentic Kerala spices and bold Guntur Karam for unforgettable flavour",
    },
    {
      id: 2,
      key: "Chef-ready Convenience",
      image: "Chef-ready_Convenience.webp",
      title: "Chef-ready Convenience",
      description:
        "No prep, no mess—ready-to-cook for quick turnaround in commercial or home kitchens",
    },
    {
      id: 3,
      key: "Consistent Quality",
      image: "Consistent_Quality.webp",
      title: "Consistent Quality",
      description:
        "Each batch is marinated to perfection, ensuring uniform flavor and tenderness",
    },
    {
      id: 4,
      key: "Versatile Cooking Options",
      image: "Versatile_Cooking_Options.webp",
      title: "Versatile Cooking Options",
      description:
        "Ideal for grilling, pan-frying, roasting, or tandoor—delivers excellence every time",
    },
  ],
  why_choose_section: {
    title: "Why Choose Our Marinated Chicken",
    description: "Discover the perfect blend of convenience, quality, and authentic flavors that make our marinated chicken stand out.",
  },
};

export default fruitPulpData;
